import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=201ad598&"
import script from "./ProfilePicture.vue?vue&type=script&lang=js&"
export * from "./ProfilePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports